require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2009-08-12-comcast-sucks.json") })
        }
      }, "path---articles-2009-08-12-comcast-sucks");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2009-08-12-comcast-sucks!./.cache/json/articles-2009-08-12-comcast-sucks.json
// module id = 573
// module chunks = 231608221292675